import React, { useState, useEffect } from "react"
import { DebounceInputSearch, UFDate, UFInput } from "../../../components/Common/Fields/Input"
import { Col, Form, Row } from "reactstrap"
import resetIcon from "../../../assets/icons/reset.svg"
import { Controller, useForm } from "react-hook-form"
import ProductList from "../../../components/Common/chooseFields/productList"
import FinanceLedgersLi from "../../../components/Common/chooseFields/ledgers"
import { useSelector } from "react-redux"
import { isEmpty } from "lodash"
import moment from "moment"
import { DebounceInput } from "react-debounce-input"

const StockJournalFilter = ({
  //   handleCCChange,
  handleSearchChange,
  handleProductChange,
  handleLedgerChange,
  //   handleTHChange,
  handleFinacialChange,
  // handilHardResetApi,
  handleDateChange,
  productId,
  productName,
  productCode,
}) => {
  const { control, watch, reset, setValue } = useForm({
    defaultValues: {
      req_date: [moment().startOf("month").toDate(), moment().toDate()],
    },
  })
  console.log(`productId chk :`, productId)

  const loggedUser = useSelector(state => state.Login.loggedUser)
  const [companyCheck, setCompanyCheck] = useState(false)
  const [finacialCheck, setfinacialCheck] = useState(true)
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  )
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"))

  useEffect(() => {
    if (productId) {
      setValue("product_id", {
        label: `${productCode} - ${productName}`,
        value: productId,
      })
      handleProductChange(productId)
    }
  }, [productId])

  //   const handleTransactionHistory = data => {
  //     handleTHChange(data?.label)
  //   }
  //   const handleCCNum = data => {
  //     handleCCChange(data?.value)
  //   }
  const handleProducttNum = data => {
    handleProductChange(data?.value)
  }
  const handleLedger = data => {
    handleLedgerChange(data?.value)
  }
  useEffect(() => {
    handleSearchChange(watch("search"))
  }, [watch("search")])
  const handleReset = () => {
    // handleCCChange()
    // handleTHChange()
    handleProductChange()
    handleLedgerChange()
    handleFinacialChange(true)
    // handleCompanyChange(false)
    setfinacialCheck(true)
    reset({
      costcenter_id: null,
      product_id: null,
      search: "",
      th_no: null,
      ledger_id: null,
      //   req_date: [moment().startOf("month").toDate(), moment().toDate()],
    })
    setStartDate(moment().startOf("month").format("YYYY-MM-DD"))
    setEndDate(moment().format("YYYY-MM-DD"))
  }

  const handleFinacialCheck = dt => {
    handleFinacialChange(!dt)
    setfinacialCheck(!dt)
  }

  const handleRequestdate = data => {
    console.log(data, "data")
    let fromDate = ""
    let toDate = ""
    fromDate = !isEmpty(data) ? moment(data[0]).format("YYYY-MM-DD") : ""
    toDate = !isEmpty(data) ? moment(data[1]).format("YYYY-MM-DD") : ""
    setStartDate(fromDate)
    setEndDate(toDate)
    handleDateChange(startDate, endDate)
  }

  // const handilHardRest = () => {
  //   handilHardResetApi()
  // }

  useEffect(() => {
    handleDateChange(startDate, endDate)
  }, [startDate, endDate])

  return (
    <div className="d-flex justify-content-between align-items-center my-2 me-2">
      <Form id="user-form" className="filter-wrapper">
        <Row className="mx-0">
          <Col sm={3} className="pe-1">
            <ProductList
              control={control}
              name={"product_id"}
              placeholder={"Select Product"}
              target={"body"}
              onSelectChange={e => handleProducttNum(e)}
              filter={true}
            />
          </Col>
          <Col sm={3} className="pe-1">
            <UFDate
              control={control}
              placeholder="Date"
              name={"req_date"}
              mode="range"
              className="ufinput-dashboard"
              onDateChange={e => handleRequestdate(e)}
              defaultValue={[
                moment().startOf("month").toDate(),
                moment().toDate(),
              ]}
            />
          </Col>
          <Col sm={3} className="pe-1">
            <FinanceLedgersLi
              control={control}
              placeholder="Select"
              name={"ledger_id"}
              target={"body"}
              groupId="12"
              onSelectChange={e => handleLedger(e)}
            />
          </Col>
        </Row>
      </Form>
      <div className="d-flex">
        {/* <div
          className="export-div pointer me-2 reset-img"
          onClick={() => handilHardRest()}
          title="Hard Refresh"
        >
          <img
            src={resetIcon}
            height={15}
            width={15}
            className=""
            alt="hard refresh"
          />
        </div> */}
        <div
          className="export-div pointer me-2 ms-0 reset-img"
          onClick={() => handleReset()}
        >
          <img
            src={resetIcon}
            height={15}
            width={15}
            className="me-2"
            alt="refresh"
          />{" "}
          Reset
        </div>
        <DebounceInputSearch
            control={control}
            placeholder={"Search"}
            name={"search"}
            className={"search-input"}
            minLength={1}
            debounceTimeout={700}
          />
        {/* <UFInput
          control={control}
          placeholder="Search"
          name={"search"}
          className={"search-input"}
        /> */}
      </div>
    </div>
  )
}

export default StockJournalFilter
